import ReviewsSlider from "../../../components/reviews-slider";
export default class PageModule {
	constructor() {
		this.reviewsSlider = new ReviewsSlider();
	}
}